/**
 * 三包登记的 表单验证规则
 * @author zjs
 * @time 2017-09-21
 */
export default {
    data () {
        // 非空的判断
        var isNoEmpty = (rule, value, callback) => {
            if (value === '' || value === undefined) {
                callback(new Error('请输入'))
            } else {
                callback()
            }
        }
        return {
            formRules: {
                account_code: [{ required: true, trigger: 'blur' }],
                account_name: [{ required: true, trigger: 'blur' }],
                account_number: [{ required: true, trigger: 'blur' }],
                qichu_balance: [{ validator: isNoEmpty, required: true, trigger: 'blur' }]
            }
        }
    }
}